import { helper } from '@ember/component/helper';

import { htmlSafe } from '@ember/template';

import ENV from 'rise-ui/config/environment.js';

export default helper(function deployIdHelper() {
  const deployIdString = (ENV.APP.DEPLOY?.COMMENT || '%s')
    .replace('%s', ENV.APP.DEPLOY?.ID || '')
    .replaceAll('>', '&gt;');
  return htmlSafe(`<!-- ${deployIdString} -->`);
});
